module.exports = __webpack_public_path__ + "img/Documents.fd90d7d8.svg";